/**
 * start_param запуска мини-аппа. По ссылке t.me/…?startapp=… Telegram передаёт его
 * в tgWebAppStartParam и в initData (start_param).
 */
export function getStartParam(): string | null {
  const search = new URLSearchParams(window.location.search);
  const fromSearch = search.get("tgWebAppStartParam") ?? search.get("startapp");
  if (fromSearch) return fromSearch;

  try {
    const hash = new URLSearchParams(window.location.hash.slice(1));
    const fromHash = hash.get("tgWebAppStartParam");
    if (fromHash) return fromHash;

    return new URLSearchParams(hash.get("tgWebAppData") ?? "").get(
      "start_param"
    );
  } catch {
    return null;
  }
}

const APP_LOGIN = /^applogin(?:_(\d{6}))?$/;

/**
 * Вход в приложение BK VPN на компьютере: startapp=applogin_<код>.
 * Просто applogin — код человек введёт сам.
 */
export function getAppLoginParam(): { code: string } | null {
  const param = getStartParam();
  const match = param ? APP_LOGIN.exec(param) : null;

  return match ? { code: match[1] ?? "" } : null;
}

/** Для аналитики: одноразовый код входа не отправляем. */
export function startParamForAnalytics(param: string): string {
  return APP_LOGIN.test(param) ? "applogin" : param;
}
